export default "__VITE_ASSET__BhE$AqvW__"